import React, { FC, PropsWithChildren } from "react";
import { Divider, Grid, Group } from "@mantine/core";
import styles from "./styles.module.css";

export const SettingsFormContent: FC<PropsWithChildren> = (props) => (
  <div className={styles.settingsFormContent} {...props} />
);

export const SettingsFormCTAs: FC<PropsWithChildren> = (props) => (
  <div className={styles.settingsFormCtas} {...props} />
);

export const SettingsHeader: FC<PropsWithChildren<{ showDivider?: boolean }>> = ({ showDivider = true, children }) => (
  <React.Fragment>
    <Grid.Col span={12}>
      <Group justify={"space-between"} align={"center"} style={{ minHeight: "1.4rem" }}>
        {children}
      </Group>
    </Grid.Col>
    {showDivider && (
      <Grid.Col span={12}>
        <Divider />
      </Grid.Col>
    )}
  </React.Fragment>
);
